import { sharedCatalog } from "@shared/locales/en/US/sharedCatalog";

const catalog = {
  ...sharedCatalog,
  header: {
    Catalog: "Catalog",
    Favorites: "Favorites",
    TaxExemption: "Tax exemption",
    EverythingYouNeedToExplore:
      "Everything you need to explore, discover, and find the right product faster and easier than ever.",
    ShopWholesale: "Shop wholesale",
    Promotions: "Promotions",
    IndustryLeadingCatalog:
      "Our industry leading catalog has everything you need to explore, discover, and make {{treatmentPlanTermPresentParticiple}} faster and easier than ever.",
    IndustryLeadingCatalogPlan:
      "Our industry leading catalog has everything you need to explore, discover, and build a plan faster and easier than ever.",
    SearchDiscoverTreatmentPlan: "Search, discover, {{treatmentPlanTermVerb}}",
    SearchDiscoverPlan: "Search, discover, build a plan",
  },

  banners: {
    SwapProduct: "Swap product",
    swapAria: "catalog is in swap mode for the chosen product",
    AddingProductsTo: "Adding products to ",
    favoritesAria: "Catalog is set to add any chosen products to the specified favorite category",
    dailyPacksTitle: "A unique daily pack for every patient",
    dailyPacksBody: "Improve patient adherence by creating custom daily packs while prescribing.",
    createDailyPack: "Create daily pack",
    learnMore: "Learn more",
  },
  WhatsInside: "What's inside",
} as const;

export { catalog };
